/* Luxury Box collection filters — chips + bottom sheets (mobile) / left rail (desktop).
   Works on top of Shopify's native storefront filters: every input keeps its
   param_name/value, so applying = building a URL and navigating (canonical, shareable).
   Preview counts come from the Section Rendering API. No size conversion anywhere. */
(function () {
  'use strict';
  var SIZE_KEY = 'lb_size';           // {us:"10.5", eu:"44", apparel:"L", waist:"32"}
  var ONLY_KEY = 'lb_only_mine';      // "1" | "0"
  var SIZE_PARAM = 'filter.v.option.size';
  var AVAIL_PARAM = 'filter.v.availability';

  function readSize() { try { return JSON.parse(localStorage.getItem(SIZE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function onlyMine() { try { var v = localStorage.getItem(ONLY_KEY); return v === null ? true : v === '1'; } catch (e) { return true; } }
  function setOnlyMine(on) { try { localStorage.setItem(ONLY_KEY, on ? '1' : '0'); } catch (e) {} }

  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = '1';
    var sectionId = root.dataset.sectionId;
    var baseUrl = root.dataset.collectionUrl || location.pathname;
    var inStockOnly = root.dataset.inStockOnly === 'true';
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lb-panel]'));
    var scrim = root.querySelector('[data-lb-scrim]');
    var badge = root.querySelector('[data-lb-badge]');
    var isDesktop = function () { return window.matchMedia('(min-width: 1024px)').matches; };
    var previewTimer = null, previewReq = 0;

    // sticky offset under the theme header
    var header = document.querySelector('.theme__header, [data-header-height], .site-header');
    if (header) root.style.setProperty('--lb-sticky-top', Math.max(0, Math.round(header.getBoundingClientRect().height)) + 'px');

    // ---------- URL building ----------
    function currentParams() {
      var p = new URLSearchParams(location.search);
      p.delete('page');
      return p;
    }
    function paramsFromInputs(scopePanel) {
      // Start from the URL, replace the params owned by panels with their current input state.
      var p = currentParams();
      var owned = {};
      panels.forEach(function (panel) {
        panel.querySelectorAll('input[name^="filter."]').forEach(function (i) { owned[i.name] = true; });
      });
      Object.keys(owned).forEach(function (k) { p.delete(k); });
      panels.forEach(function (panel) {
        panel.querySelectorAll('input[name^="filter."]').forEach(function (i) {
          if (i.type === 'checkbox') {
            if (i.checked) {
              p.append(i.name, i.value);
              if (i.dataset.lbAlso) i.dataset.lbAlso.split('|').forEach(function (v) { if (v) p.append(i.name, v); });
            }
          }
          else if (i.type === 'number') { if (i.value !== '') p.set(i.name, i.value); }
        });
      });
      if (inStockOnly && !p.has(AVAIL_PARAM)) p.set(AVAIL_PARAM, '1');
      return p;
    }
    function go(p) {
      var qs = p.toString();
      location.assign(baseUrl + (qs ? '?' + qs : ''));
    }

    // ---------- preview count ----------
    function refreshPreview(panel) {
      clearTimeout(previewTimer);
      previewTimer = setTimeout(function () {
        var p = paramsFromInputs();
        p.set('section_id', sectionId);
        var req = ++previewReq;
        var out = panel.querySelector('[data-lb-preview]');
        if (out) out.textContent = '…';
        fetch(baseUrl + '?' + p.toString(), { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (req !== previewReq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('[data-section-type="luxbox-collection"]');
            var n = el ? parseInt(el.dataset.count || '0', 10) : 0;
            if (out) out.textContent = n.toLocaleString();
            var apply = panel.querySelector('[data-lb-apply]');
            if (apply) apply.disabled = (n === 0);
          }).catch(function () { if (out) out.textContent = ''; });
      }, 250);
    }

    // ---------- open / close sheets ----------
    var openPanel = null;
    function open(key) {
      var panel = key === 'all' ? panels[0] : root.querySelector('[data-lb-panel="' + key + '"]');
      if (!panel) return;
      if (isDesktop()) { panel.removeAttribute('data-collapsed'); panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); return; }
      close();
      panel.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      openPanel = panel;
      refreshPreview(panel);
    }
    function close() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      openPanel = null;
    }
    function filterList(input) {
      var q = (input.value || '').trim().toLowerCase();
      var list = input.closest('.lb-list');
      list.querySelectorAll('[data-lb-item]').forEach(function (it) { it.style.display = (!q || it.dataset.lbItem.indexOf(q) !== -1) ? '' : 'none'; });
    }

    // ---------- events ----------
    function onClick(e) {
      var t = e.target;
      var opener = t.closest('[data-lb-open]');
      if (opener) { e.preventDefault(); open(opener.dataset.lbOpen); return; }
      if (t.closest('[data-lb-close]') || t === scrim) { e.preventDefault(); close(); return; }
      var apply = t.closest('[data-lb-apply]');
      if (apply) { e.preventDefault(); go(paramsFromInputs()); return; }
      var clr = t.closest('[data-lb-clear]');
      if (clr) {
        e.preventDefault();
        var key = clr.dataset.lbClear;
        var scope = key === 'all' ? panels : [root.querySelector('[data-lb-panel="' + key + '"]')];
        scope.forEach(function (panel) { if (!panel) return; panel.querySelectorAll('input').forEach(function (i) { if (i.type === 'checkbox' || i.type === 'radio') i.checked = false; else if (i.type === 'number' || i.type === 'search') i.value = ''; }); });
        if (isDesktop()) go(paramsFromInputs()); else refreshPreview(clr.closest('.lb-panel'));
        return;
      }
      var band = t.closest('[data-lb-band]');
      if (band) {
        var panel = band.closest('[data-lb-panel]');
        var mn = panel.querySelector('input[name$=".gte"]'), mx = panel.querySelector('input[name$=".lte"]');
        if (mn) mn.value = band.dataset.min === '0' ? '' : band.dataset.min;
        if (mx) mx.value = (band.dataset.max === '0' || band.dataset.max === '') ? '' : band.dataset.max;
        if (isDesktop()) go(paramsFromInputs());
        return;
      }
      var head = t.closest('.lb-panel__head');
      if (head && isDesktop() && !t.closest('[data-lb-close]')) { var pnl = head.closest('[data-lb-panel]'); if (pnl.hasAttribute('data-collapsed')) pnl.removeAttribute('data-collapsed'); else pnl.setAttribute('data-collapsed', ''); }
      var edit = t.closest('[data-lb-edit-size]');
      if (edit) { e.preventDefault(); if (window.LuxboxNav) window.LuxboxNav.open('size'); else location.href = '/'; }
      var clr = t.closest('[data-lb-clear-size]');
      if (clr) {
        e.preventDefault();
        try { localStorage.removeItem(SIZE_KEY); } catch (err) {}
        window.dispatchEvent(new CustomEvent('lb:size', { detail: {} }));
        var cp = currentParams();
        if (cp.getAll(SIZE_PARAM).length) { cp.delete(SIZE_PARAM); go(cp); }
        return;
      }
      var sw = t.closest('[data-lb-only-mine]');
      if (sw) { e.preventDefault(); var on = !sw.classList.contains('is-on'); setOnlyMine(on); sw.classList.toggle('is-on', on); sw.setAttribute('aria-checked', String(on)); applyMySize(on, true); }
    }
    root.addEventListener('click', onClick);
    root.addEventListener('change', function (e) {
      var panel = e.target.closest('[data-lb-panel]');
      if (!panel) {
        if (e.target.matches('[data-lb-sort]')) { var p = currentParams(); p.set('sort_by', e.target.value); go(p); }
        return;
      }
      if (isDesktop()) { if (e.target.type === 'checkbox') go(paramsFromInputs()); }
      else refreshPreview(panel);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Enter' && e.target.type === 'number' && isDesktop()) { e.preventDefault(); go(paramsFromInputs()); }
    });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-lb-search]')) filterList(e.target); });
    root.querySelectorAll('.lb-price input').forEach(function (i) { i.addEventListener('change', function () { if (isDesktop()) go(paramsFromInputs()); }); });

    // size cells arrive in Shopify's order; show them numerically (letters in wear order)
    var LETTER_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL', '4XL', 'XXXXL', 'OS', 'ONE SIZE'];
    function sizeRank(v) {
      var n = parseFloat(v); if (!isNaN(n)) return n;
      var i = LETTER_ORDER.indexOf(String(v).toUpperCase()); return i === -1 ? 999 : 100 + i;
    }
    root.querySelectorAll('[data-lb-size-group] .lb-cells').forEach(function (grid) {
      var cells = Array.prototype.slice.call(grid.children);
      cells.sort(function (a, b) { return sizeRank(a.querySelector('input').dataset.lbSizeValue) - sizeRank(b.querySelector('input').dataset.lbSizeValue); });
      cells.forEach(function (c) { grid.appendChild(c); });
    });

    // synthesized size cells (S&D value groups hide the raw sizes): Liquid can't see the URL,
    // so mark them checked here and reflect that in the chip + badge
    (function syncSynth() {
      var urlSizes = currentParams().getAll(SIZE_PARAM);
      if (!urlSizes.length) return;
      var hit = [];
      root.querySelectorAll('[data-lb-synth][data-lb-size-value]').forEach(function (i) {
        if (urlSizes.indexOf(i.value) !== -1) { i.checked = true; hit.push(i.dataset.lbSizeValue); }
      });
      if (!hit.length) return;
      var chip = root.querySelector('[data-lb-open="v-option-size"]');
      if (chip && !chip.classList.contains('is-active')) {
        chip.classList.add('is-active');
        chip.childNodes[0].nodeValue = 'Size · ' + hit.join(', ');
        if (badge) { var n = parseInt(badge.textContent || '0', 10) || 0; badge.textContent = n + 1; badge.hidden = false; }
        var bar = root.querySelector('[data-lb-bar]');
        if (bar && !bar.querySelector('.lb-chip--clear')) { var a = document.createElement('a'); a.className = 'lb-chip lb-chip--clear'; a.href = baseUrl; a.textContent = 'Clear all'; bar.appendChild(a); }
      }
    })();
    // empty state: say which size came up empty, and offer "Show all sizes" (keeps the other filters)
    (function emptyState() {
      var a = root.querySelector('[data-lb-clear-size-link]'); if (!a) return;
      var p = currentParams(); var sizes = p.getAll(SIZE_PARAM); if (!sizes.length) return;
      var msg = root.querySelector('[data-lb-empty-msg]');
      if (msg) msg.textContent = 'Nothing in ' + sizes.join(' / ') + ' right now.';
      p.delete(SIZE_PARAM); a.href = baseUrl + (p.toString() ? '?' + p.toString() : ''); a.hidden = false;
    })();

    // list panels: options with zero matches sink to the bottom
    root.querySelectorAll('.lb-list').forEach(function (list) {
      Array.prototype.slice.call(list.querySelectorAll('[data-lb-item]')).forEach(function (it) {
        var i = it.querySelector('input'); if (i && i.disabled) list.appendChild(it);
      });
    });

    // ---------- "your size" ----------
    var sizePanel = root.querySelector('[data-lb-panel="v-option-size"]');
    function savedValuesPresent() {
      var s = readSize(); var vals = [s.us, s.eu, s.apparel, s.waist].filter(Boolean).map(String);
      if (!sizePanel || !vals.length) return [];
      var present = [];
      sizePanel.querySelectorAll('[data-lb-size-value]').forEach(function (i) { if (vals.indexOf(i.dataset.lbSizeValue) !== -1 && !i.disabled) present.push(i.dataset.lbSizeValue); });
      return present;
    }
    function renderMySize() {
      var box = root.querySelector('[data-lb-mysize]'); if (!box) return;
      var s = readSize(); var cells = box.querySelector('[data-lb-mysize-cells]');
      var items = [['US', s.us], ['EU', s.eu], ['', s.apparel], ['W', s.waist]].filter(function (x) { return x[1]; });
      if (!items.length) { box.removeAttribute('data-has-size'); return; }
      box.setAttribute('data-has-size', '');
      cells.innerHTML = items.map(function (x) { return '<span class="lb-mysize__cell">' + (x[0] ? x[0] + ' ' : '') + x[1] + '</span>'; }).join('');
      var sw = box.querySelector('[data-lb-only-mine]'); var on = onlyMine(); sw.classList.toggle('is-on', on); sw.setAttribute('aria-checked', String(on));
    }
    function applyMySize(on, navigate) {
      var present = savedValuesPresent();
      var p = currentParams();
      var urlSizes = p.getAll(SIZE_PARAM);
      if (on) {
        if (!present.length) return;
        if (urlSizes.length) return; // shopper already chose sizes on this page
        p.delete(SIZE_PARAM); present.forEach(function (v) { p.append(SIZE_PARAM, v); });
        if (inStockOnly) p.set(AVAIL_PARAM, '1');
        try { sessionStorage.setItem('lb_auto_size', '1'); } catch (e) {}
        go(p);
      } else if (navigate) {
        p.delete(SIZE_PARAM); go(p);
      }
    }
    renderMySize();
    // the nav drawer edits the saved size: re-render, and once it closes, apply it
    window.addEventListener('lb:size', renderMySize);
    window.addEventListener('lb:size:commit', function () {
      renderMySize();
      var p = currentParams();
      if (!onlyMine()) return;
      var present = savedValuesPresent();
      if (!present.length) { if (p.getAll(SIZE_PARAM).length) { p.delete(SIZE_PARAM); go(p); } return; }
      p.delete(SIZE_PARAM); present.forEach(function (v) { p.append(SIZE_PARAM, v); });
      if (inStockOnly) p.set(AVAIL_PARAM, '1');
      go(p);
    });
    // Auto-apply once per page view when the shopper has a saved size and hasn't filtered yet.
    (function autoApply() {
      var p = currentParams();
      if (p.getAll(SIZE_PARAM).length) return;
      if (!onlyMine()) return;
      var present = savedValuesPresent();
      if (!present.length) return;
      var sz = readSize();
      var key = 'lb_auto_' + location.pathname + '|' + [sz.us, sz.eu, sz.apparel, sz.waist].join(',');
      try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}
      applyMySize(true, false);
    })();

    // In-stock by default is enforced before first paint by the inline script in layout/theme.liquid
    // (every /collections/ URL gets filter.v.availability=1); nav links carry it already.
  }

  function boot() { document.querySelectorAll('[data-section-type="luxbox-collection"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.LuxboxSize = { read: readSize, onlyMine: onlyMine, KEY: SIZE_KEY, ONLY_KEY: ONLY_KEY };
})();
